"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inclineFirstname = inclineFirstname;
exports.inclineLastname = inclineLastname;
exports.inclineMiddlename = inclineMiddlename;
exports.incline = incline;

var _gender = require("./gender");

var _inclineRules = require("./inclineRules");

var _inclineRulesLastname = _interopRequireDefault(require("./rules/inclineRulesLastname"));

var _inclineRulesMiddlename = _interopRequireDefault(require("./rules/inclineRulesMiddlename"));

var _inclineRulesFirstname = _interopRequireDefault(require("./rules/inclineRulesFirstname"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-use-before-define, no-continue, arrow-parens */
(0, _inclineRules.constantizeGenderInRules)(_inclineRulesLastname.default);
(0, _inclineRules.constantizeGenderInRules)(_inclineRulesMiddlename.default);
(0, _inclineRules.constantizeGenderInRules)(_inclineRulesFirstname.default);

function inclineFirstname(str) {
  var declension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'accusative';
  var gender = arguments.length > 2 ? arguments[2] : undefined;
  return (0, _inclineRules.inclineByRules)(str, declension, gender || (0, _gender.getFG)(str), _inclineRulesFirstname.default);
}

function inclineLastname(str) {
  var declension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'accusative';
  var gender = arguments.length > 2 ? arguments[2] : undefined;
  return (0, _inclineRules.inclineByRules)(str, declension, gender || (0, _gender.getLG)(str), _inclineRulesLastname.default);
}

function inclineMiddlename(str) {
  var declension = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'accusative';
  var gender = arguments.length > 2 ? arguments[2] : undefined;
  return (0, _inclineRules.inclineByRules)(str, declension, gender || (0, _gender.getMG)(str), _inclineRulesMiddlename.default);
}

function incline(person, declension) {
  var res = {};

  if (!res.gender) {
    res.gender = (0, _gender.getGender)(person);
  }

  if (person.first) {
    res.first = inclineFirstname(person.first.trim(), declension, res.gender);
  }

  if (person.last) {
    res.last = inclineLastname(person.last.trim(), declension, res.gender);
  }

  if (person.middle) {
    res.middle = inclineMiddlename(person.middle.trim(), declension, res.gender);
  }

  return res;
}